import styled from '@emotion/styled';

import { css } from 'config/emotionCss';
import colors from 'config/theme/colors';
import { Checkbox, Modal as BaseModal } from 'ui/base';

export const Content = styled('div', { target: 'fb-medias-modal-content' })`
  background-color: ${colors['@body-bg']};
`;

export const scrollableWrapperStyle = css`
  > .ant-modal {
    min-height: min(700px, calc(100vh - 200px));
  }
`;

export const scrollableContainerStyle = css`
  && {
    display: flex;
    min-height: min(700px, calc(100vh - 200px));
    max-height: calc(100vh - 200px);
    flex-direction: column;
  }
`;

export const scrollableBodyStyle = css`
  && {
    flex: 1;
    min-height: 0;
  }
`;

export const previewStyle = css`
  .ant-modal-container {
    min-height: initial !important;

    .ant-modal-header {
      display: none;
    }

    .ant-modal-body {
      justify-content: center;
      align-items: center;
      max-height: calc(100vh - 200px - 145px);
      background: #f7f7f7;
      border-radius: 3px;

      > div > div {
        width: 100%;
      }

      img,
      video {
        max-height: calc(100vh - 200px - 145px) !important;
      }
    }
  }
`;

export const Modal = styled(BaseModal)`
  .ant-modal-body {
    justify-content: stretch;
    display: flex;

    > ${Content} {
      padding: 8px;
      overflow: hidden;
      overflow-y: auto;
      width: 100%;

      display: flex;
      flex-wrap: wrap;
      flex-direction: row;
      justify-content: start;
      align-items: stretch;
      align-content: start;

      > div {
        width: calc((100% - 80px) / 5);
        flex: 0 0 auto;
        margin: 8px;
      }
    }
  }
  .ant-modal-footer {
    padding: 0 !important;
  }
`;

export const Thumbnail = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;

  pointer-events: none;

  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  background-image: url("${({ background }) => background}");

  > svg,
  > .anticon {
    font-size: 60px;
  }
`;

export const MediaWrapper = styled.div`
  cursor: pointer;
  background-color: #fff;
  border-radius: 8px;
  padding: 10px 12px 12px 12px;
  display: flex;
  box-sizing: border-box;
  box-shadow: 0 0 5px rgba(109, 141, 173, 0.05);
  border: solid 3px ${({ selected }) => (selected ? colors['@primary-color'] : 'transparent')};

  &:hover {
    border-color: ${({ selected }) => (selected ? colors['@primary-color'] : colors['@grey-20'])};
  }

  .thumbnail {
    width: 140px;
    height: 140px;
    border-radius: 12px;
    background-color: ${colors['@body-bg']};
    flex-shrink: 0;
    overflow: hidden;
  }

  > .actions {
    width: 100%;
    [class^='fb-icon'] {
      font-size: 16px;

      &.fb-icon--star-filled {
        color: #ffab00;
      }

      &.anticon-download {
        color: ${colors['@primary-color']};
      }
    }

    .filename {
      font-weight: 700;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
    }
  }
`;

export const MediaCheckbox = styled(Checkbox)`
  position: absolute;
  top: 5%;
  left: calc(50% - 16px);
  display: ${({ visible }) => (visible ? 'block' : 'none')};
  z-index: 20;
  &:hover {
    > .ant-checkbox {
      &:after {
        border: 0 !important;
      }
    }
  }
  > .ant-checkbox {
    position: absolute;
  }
`;
